<template>
    <div class="content-box">
        <Title/>

        <Textlist/>
    </div>
</template>

<script>
export default {
    name: "policy",
    data() {
        return {
            params: {
                json: 1,
            }
        }
    },
    created() {
        this.$store.commit('textparams', this.params)
        this.$store.commit('changeKeys', '跨境政策')
        this.$store.dispatch('getText')
    }
}
</script>